import DisplayIcon from "%/dynamic-component-editor/options/display-icon";
import Icon from "%/dynamic-component-editor/options/icon";
import ActiveActionIcon from "%/dynamic-component-editor/options/active-action-icon";
import IconColor from "%/dynamic-component-editor/options/icon-color";

export const ENGAGEMENT_ICONS = Object.freeze({
  like: "material-symbols:favorite-outline-rounded",
  liked: "material-symbols:favorite-rounded",
  upvote: "bx:up-arrow",
  upvoted: "bxs:up-arrow",
  downvote: "bx:down-arrow",
  downvoted: "bxs:down-arrow",
  share: "material-symbols:share-outline",
  shared: "material-symbols:check-rounded",
  votes: "bx:sort-alt-2",
  comment: "material-symbols:chat-bubble-outline-rounded",
  save: "material-symbols:bookmark-outline-rounded",
  saved: "material-symbols:bookmark-rounded",
});

export const EngagementActionMixin = {
  computed: {
    isEngagementActive() {
      return false;
    },
    engagementActiveIcon() {
      return this.getOptionValue(ActiveActionIcon);
    },
    engagementActiveIconColor() {
      return null;
    },
    myIconColor() {
      if (!this.editMode && this.isEngagementActive && this.engagementActiveIconColor) {
        return this.engagementActiveIconColor;
      }
      return this.getOptionValue(IconColor);
    },
    myIcon() {
      if (this.getOptionValue(DisplayIcon) !== "show") {
        return "";
      }
      if (!this.editMode && this.isEngagementActive) {
        return this.engagementActiveIcon;
      }
      return this.getOptionValue(Icon);
    },
    isLoading() {
      return false;
    },
  },
};
